/** @internal */
export const OP_BACK_PRESSURE = "BackPressure" as const

/** @internal */
export type OP_BACK_PRESSURE = typeof OP_BACK_PRESSURE

/** @internal */
export const OP_BUFFER_SLIDING = "BufferSliding" as const

/** @internal */
export type OP_BUFFER_SLIDING = typeof OP_BUFFER_SLIDING
